import {createAsyncThunk} from "@reduxjs/toolkit";
import axios, {AxiosError} from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import {setTestsStudentsById} from "../../../slice/test/test-students-by-id/testStudentById";
import {ApiStudentsTestResponse} from "features/model/types/test/studentTestById";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
import {setNotFoundError} from "features/model/slice/error/errorSlice";


interface getTestStudentsByIdParams {
    testId:string | undefined
    from?: string;
    to?: string;
    page?: number;
}

export const fetchTestStudentsById = createAsyncThunk(
    "tests/fetchTestStudentsById",
    async ({testId,from, to, page}: getTestStudentsByIdParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const params = createRequestParams(from, to, page);

            const response = await axios.get<ApiStudentsTestResponse>(`/api/tests/${testId}/students`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            });

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setTestsStudentsById(response.data.data));
            }


            return response.data;
        } catch (error) {
            thunkAPI.dispatch(setNotFoundError((error as AxiosError).response!.status));
        }
    }
);
